import "./Public.scss"
import Icon from "../../../components/Icon/Icon";
import {ReactComponent as ArrowSvg} from "../../../assets/separator.svg";
import {ReactComponent as AcceptSvg} from "../../../assets/accept.svg";
import {ReactComponent as SmileSvg} from "../../../assets/smile.svg";
import {ReactComponent as DocumentSvg} from "../../../assets/document.svg";
import {ReactComponent as CloseSvg} from "../../../assets/close.svg";
import Button from "../../../components/Button/Button";
import PublicTemplate from "../PublicTemplate/PublicTemplate";
import * as publicActions from "../PublicActions/PublicActions";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import classNames from "classnames";
import {useNavigate} from "react-router-dom";

const Public = () => {
    const navigate = useNavigate();
    const [customer, setCustomer] = useState(null);
    const [sent, setSent] = useState(false);
    const {id} = useParams();
    const [allSaved, setAllSaved] = useState(false);
    const [deleted, setDeleted] = useState(false);

    useEffect(() => {
        publicActions.getCustomer(id, (result) => {
            setCustomer(result);
        })
    }, [id, deleted]);

    const handleSend = () => {
        if (allSaved) {
            const payload = {
                customerForms: customer.customerForms
            }
            publicActions.updateCustomerForms(id, payload, (result) => {
                if (result.success) {
                    setSent(true)
                }
            })
        }
    }

    const handleClear = (publicId) => {
        const data = {"publicCustomerId": customer.publicId};
        publicActions.clearCustomerFormData(publicId, data, (result) => {
            if (result.success) {
                setDeleted(true);
                setAllSaved(false);
            }
        })
    }

    useEffect(() => {
        if (customer?.customerForms.every(f => f.status === "SAVED")) setAllSaved(true);
    }, [customer])

    return (
        <PublicTemplate>
            <div className="public">
                {(!sent && customer?.customerForms.length !== 0) &&
                    <>
                        <div className="info">
                            <p className="welcome">Hello, {customer?.name} {customer?.surname}</p>
                            <p>Input your data into the fields bellow. All your information will be send to us directly
                                ensuring the protection of your personal data. The forms can't be sent until all of them
                                are uploaded.
                                When everything is signed, the forms will be sent automatically.</p>
                        </div>

                        <div className="forms">
                            {customer?.customerForms?.map(
                                form => (
                                    <div className="form" key={form.form.id}>
                                        {form.form.name}
                                        {form.status === "SAVED" && (
                                            <div className="saved">
                                                <Icon svg={AcceptSvg}/>
                                                {form.form.requiresSignature && (
                                                    <div className="pdf">
                                                        <Icon svg={DocumentSvg}/>
                                                        {form.form.name}.pdf
                                                        <Button className="close-button"
                                                                onClick={() => handleClear(form.form.publicId)}>
                                                            <Icon svg={CloseSvg} className="close"/>
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <Button
                                            variant="link"
                                            onClick={() => navigate(`/form/${form.form.publicId}`, {state: {"publicCustomerId": customer?.publicId}})}
                                        >
                                            <p>{form.status === "SAVED" ?
                                                form.form.requiresSignature ? "filled and signed" : "filled" :
                                                form.form.requiresSignature ? "fill and sign" : "fill"}
                                            </p>
                                            <Icon svg={ArrowSvg}/>
                                        </Button>
                                    </div>
                                )
                            )}
                        </div>
                    </>
                }

                {sent &&
                    <div className="accept">
                        <Icon svg={AcceptSvg}/>
                        <p>Your form was submitted successfully. You can close the window. We will send you a
                            confirmation email.</p>
                    </div>
                }

                {customer?.customerForms.length === 0 &&
                    <div className="empty">
                        <Icon svg={SmileSvg}/>
                        <p>You have no forms to fill out.</p>
                    </div>
                }

            </div>

            {customer?.customerForms.length !== 0 && allSaved && !sent && !deleted &&
                <div className="returned">
                    <div className="stripe">
                        <span className="line"></span>
                        <span>All your forms have been filled and saved. Now you can send them back.</span>
                        <span className="line"></span>
                    </div>
                    <Button className="send" onClick={handleSend}>
                        Send All
                    </Button>
                </div>
            }
        </PublicTemplate>
    )
}

export default Public;